var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCoopmodel = function SvgCoopmodel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#38A169",
    clipPath: "url(#coopmodel_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    opacity: 0.1,
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 14.667a2.667 2.667 0 1 0 0-5.333 2.667 2.667 0 0 0 0 5.333Zm-4.334 2a1.667 1.667 0 1 0 0-3.334 1.667 1.667 0 0 0 0 3.334ZM22 15a1.667 1.667 0 1 1-3.334 0A1.667 1.667 0 0 1 22 15Zm-6 .334a3.333 3.333 0 0 1 3.333 3.333v4h-6.667v-4A3.333 3.333 0 0 1 16 15.333Zm-4.667 3.333c0-.462.067-.908.192-1.33l-.113.01a2.334 2.334 0 0 0-2.079 2.32v3h2v-4Zm11.333 4v-3c0-1.242-.97-2.257-2.192-2.33.125.422.192.868.192 1.33v4h2Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "coopmodel_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h32v32H0z"
  })))));
};
export default SvgCoopmodel;